import React from "react";
import { Icon } from "@livingmap/hippo";

import { TextAndNumberInterface } from "../FormControl";
import styles from "./TextNumberInput.module.scss";
import classNames from "classnames";

const TextNumberInput: React.FC<TextAndNumberInterface> = ({
  dataQA,
  iconPosition = "left",
  onIconClick,
  error,
  label,
  id,
  icon,
  value,
  ...inputProps
}) => {
  const hasError = Boolean(error);
  const errorId = hasError ? `${id}-error` : undefined;
  const inputValue = value ?? "";

  return (
    <div data-qa={dataQA} className={styles.container}>
      {label && (
        <label
          htmlFor={id}
          className={classNames(styles.label, {
            [styles.errorLabel]: hasError,
          })}
        >
          {label}
        </label>
      )}
      {icon ? (
        <label
          className={classNames(styles.iconLabel, {
            [styles.iconRight]: iconPosition === "right",
            [styles.iconLeft]: iconPosition === "left",
          })}
        >
          <span onClick={onIconClick}>
            <Icon dataQA="input-icon" {...icon} />
          </span>
          <input
            {...inputProps}
            id={id}
            value={inputValue}
            className={classNames(styles.iconInput, {
              [styles.errorInput]: hasError,
            })}
            aria-invalid={hasError}
            aria-describedby={errorId}
          />
        </label>
      ) : (
        <input
          {...inputProps}
          id={id}
          value={inputValue}
          className={classNames(styles.input, {
            [styles.errorInput]: hasError,
          })}
          aria-invalid={hasError}
          aria-describedby={errorId}
        />
      )}
      {hasError && (
        <span className={styles.errorText} id={errorId}>
          {error}
        </span>
      )}
    </div>
  );
};

export default TextNumberInput;
